import { useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyInformationClipboard } from '@root/entities/currency/ui'
import { PairBoostersBadge } from '@root/entities/pair/ui'
import { PairRank } from '@root/entities/pair/ui/pair-rank'
import { TierRank, TierRankGradient } from '@root/entities/tier-rank'
import { Truncate } from '@root/shared/ui-kit'

import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium'

type Props = {
  currency: CurrencyModel
  premium: PremiumMetaModel
}

export const PremiumListItemInformation: React.FC<Props> = ({
  currency,
  premium: premiumInfo,
}) => {
  const [tier] = useAtom(premiumInfo.tier)
  const tierRank = tier ? TierRank.fromPremiumTier(tier) : undefined
  return (
    <Root>
      <Top>
        <Ticker $tierRank={tierRank}>{currency.ticker}</Ticker>

        <PairRank rank={0} />
        <PairBoostersBadge currency={currency} premiumInfo={premiumInfo} />
      </Top>
      <Bottom>
        <Title>{currency.title}</Title>
        <Address>
          <Truncate start={5} end={4}>
            {currency.address}
          </Truncate>
        </Address>
        <CurrencyInformationClipboard currency={currency} />
      </Bottom>
    </Root>
  )
}

const Root = styled.div`
  display: grid;

  grid-template-rows: auto auto;
  justify-items: start;
  align-items: center;

  gap: 2px;
`

const Top = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;

  align-items: center;

  gap: 6px;
`

const Bottom = styled.div`
  color: var(--text-11);

  display: grid;
  gap: 2px;
  grid-auto-flow: column;
  grid-auto-columns: auto;

  justify-items: start;
  align-items: center;

  > svg {
    cursor: pointer;
  }
`

const Ticker = styled(Typography)<{ $tierRank: TierRank.TierRank | undefined }>`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 115%;
  letter-spacing: 0.48px;

  cursor: pointer;

  ${({ $tierRank }) =>
    $tierRank
      ? TierRankGradient.tierRankTextGradientCss($tierRank)
      : css`
          color: var(--text-12);
        `}
`

const Title = styled(Typography)`
  margin-inline-end: 4px;
  line-height: normal;
`

const Address = styled(Typography)`
  font-size: 10px;
  font-weight: 600;
`
